import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

export interface Props extends SvgIconProps {}

const InstructorIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon width={20} height={21} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.99996 9.66667C10.6592 9.66667 11.3037 9.47117 11.8519 9.1049C12.4 8.73863 12.8273 8.21803 13.0796 7.60895C13.3319 6.99986 13.3979 6.32964 13.2692 5.68303C13.1406 5.03643 12.8232 4.44249 12.357 3.97631C11.8908 3.51014 11.2969 3.19267 10.6503 3.06405C10.0037 2.93543 9.33344 3.00144 8.72435 3.25374C8.11526 3.50603 7.59467 3.93327 7.22839 4.48143C6.86212 5.0296 6.66663 5.67406 6.66663 6.33334C6.66663 7.21739 7.01782 8.06524 7.64294 8.69036C8.26806 9.31548 9.1159 9.66667 9.99996 9.66667Z"
        fill="currentColor"
      />
      <path
        d="M15 18C15.221 18 15.4329 17.9122 15.5892 17.7559C15.7455 17.5996 15.8333 17.3877 15.8333 17.1667C15.8333 15.6196 15.2187 14.1358 14.1247 13.0419C13.0308 11.9479 11.5471 11.3333 9.99996 11.3333C8.45286 11.3333 6.96913 11.9479 5.87517 13.0419C4.78121 14.1358 4.16663 15.6196 4.16663 17.1667C4.16663 17.3877 4.25442 17.5996 4.4107 17.7559C4.56698 17.9122 4.77895 18 4.99996 18H15Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default InstructorIcon;
